import styled from 'styled-components';

export const ChatListBlock = styled.div`
  max-height: 400px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }
`;
export const ChatListItem = styled.div`
  border-bottom: 1px solid #f1f5f9;
  padding: 12px;
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }
`;
export const ChatListItemBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const ChatListItemImg = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
`;
export const ChatListItemTitleBlock = styled.div`
  margin-left: 16px;
`;

export const ChatListItemLeftSide = styled.div`
  display: flex;
`;

export const ChatListItemRightSide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
`;

export const ChatListItemTitle = styled.h5`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #212529;
`;
export const ChatListItemText = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${({ $hasUnread }) => ($hasUnread ? '#212529' : '#6c757d')};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  word-break: break-word;
`;
export const ChatListItemTime = styled.p`
  font-weight: 400;
  font-size: 10px;
  line-height: 15px;
  color: #62748e;
`;

export const UnreadBadge = styled.div`
  min-width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #2d6cdf;
  color: #ffffff;
  font-size: 9px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4.8px 4.8px 0px #00000040;
`;
